module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//btn-0.png?v=ebcb4c17";